/**
 * GIWAHS Adaptive Journey — Deterministic Integrity Hash (AJIP-16.02.004)
 * ---------------------------------------------------------------------
 * Per Founder Ruling P-03: an integrity checksum is required. It is
 * NOT a security feature. This module provides a deterministic,
 * dependency-free hash suitable for detecting accidental corruption
 * of a serialised persisted record.
 *
 * Algorithm
 *   FNV-1a 32-bit. Chosen for:
 *     * Deterministic across Node and browser.
 *     * Zero dependencies.
 *     * Fast and small (bundle cost is negligible).
 *     * Sufficient for accidental-corruption detection.
 *
 * Contract
 *   fnv1a(input) → 8-character lowercase hex string.
 *
 * Not to be used for cryptographic authentication or tamper-resistance.
 * Future packages may substitute a cryptographic hash if authorised.
 */

const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

const fnv1a = (input) => {
  const s = typeof input === 'string' ? input : JSON.stringify(input);
  let hash = FNV_OFFSET_BASIS;
  for (let i = 0; i < s.length; i += 1) {
    hash ^= s.charCodeAt(i);
    // 32-bit unsigned multiply.
    hash = Math.imul(hash, FNV_PRIME) >>> 0;
  }
  return hash.toString(16).padStart(8, '0');
};

const CHECKSUM_ALGORITHM = 'fnv1a-32';

export { fnv1a, CHECKSUM_ALGORITHM };
